import { shouldShowA2HSNudge } from 'mini-a2hs/lib/utils/shouldShowA2HSNudge';

export const getSidePaneNewItemList = async () => {
    let items = [];

    // push A2HSBanner to the list of items to show in the side pane
    const showA2HSNudge = await shouldShowA2HSNudge();
    if (showA2HSNudge) {
        items.push('A2HSBanner');
    }

    return items;
};
